import { createAction, props } from '@ngrx/store';
import { Booking } from '../models/booking';
import { BookingFilter } from '../models/booking.filter';
import { Review } from '@shared/models/review';
import { Participant } from '@modules/course/classroom/models/participant';
import { Feedback } from '@modules/course/classroom/models/feedback';
import { ReviewReq as InstructorReview } from '@modules/instructor/models/review';

export const AddBookings = createAction('ADD BOOKINGS', props<{ bookings: Booking[] }>());

export const AddMoreBookings = createAction('ADD MORE BOOKINGS', props<{ bookings: Booking[] }>());

export const AddBooking = createAction('ADD BOOKING', props<{ booking: Booking }>());

export const AddError = createAction('ADD BOOKING ERROR', props<{ error: any }>());

export const AddTotalCount = createAction('ADD TOTAL COUNT BOOKING', props<{ totalCount: number }>());

export const ActiveTotalCount = createAction('ADD ACTIVE COUNT BOOKING', props<{ activeCount: number }>());

export const PendingTotalCount = createAction('ADD PENDING COUNT BOOKING', props<{ pendingCount: number }>());

export const UpcomingTotalCount = createAction('ADD UPCOMING COUNT BOOKING', props<{ upcomingCount: number }>());

export const HistoryTotalCount = createAction('ADD HISTORY COUNT BOOKING', props<{ historyCount: number }>());

export const UpdateBooking = createAction('UPDATE BOOKING', props<{ id: string; change: Booking }>());

export const AddBookingFilter = createAction('ADD BOOKING FILTER', props<{ filter: BookingFilter }>());

export const RemoveBookingFilter = createAction('REMOVE BOOKING FILTER');

export const DeleteBooking = createAction('DELETE BOOKING', props<{ id: string }>());

export const UpdateBookingSuccess = createAction('[APPROVE] UPDATE BOOKING SUCCESS');

export const ApproveBookingSuccess = createAction('[APPROVE] APPROVE BOOKING SUCCESS');

export const SetUserMode = createAction('[BOOKING] SET USER MODE', props<{ isGuide: boolean }>());

export const AddBookingReview = createAction('Add Booking Review', props<{ review: Review }>());

export const UpdateBookingReviewState = createAction('[BOOKING] UPDATE BOOKING REVIEW STATE', props<{ serviceId: string }>());

export const AddIsCourseBooked = createAction('Add Is Course Booked', props<{ isCourseBooked: boolean }>());

export const RemoveIsCourseBooked = createAction('Remove Is Course Booked');

export const UpdateBookingReschedule = createAction('UPDATE BOOKING RESCHEDULE', props<{ booking: Booking }>());

export const AddParticipants = createAction('ADD PARTICIPANTS', props<{ participants: Participant[] }>());

export const RemoveParticipants = createAction('REMOVE PARTICIPANTS');

export const UpdatePageIndex = createAction('[Api] UPDATE PAGE INDEX');

export const ResetPageIndex = createAction('[Api] RESET PAGE INDEX');

export const ResetBookingStore = createAction('RESET BOOKING STORE');

// Effects actions

export const FetchBookings = createAction(
  '[Api] FETCH BOOKINGS',
  props<{
    search: string;
    filter: BookingFilter;
    pageIndex: number;
    pageSize: number;
    sort: string;
  }>()
);

export const FetchMoreBookings = createAction(
  '[Api] FETCH MORE BOOKINGS',
  props<{
    search: string;
    filter: BookingFilter;
    pageIndex: number;
    pageSize: number;
    sort: string;
  }>()
);

export const FetchSingleBookings = createAction(
  '[Api] FETCH SINGLE BOOKINGS',
  props<{
    search: string;
    filter: BookingFilter;
    pageIndex: number;
    pageSize: number;
    sort: string;
  }>()
);

export const GetBooking = createAction('[Api] GET BOOKING', props<{ id: string }>());

export const SaveBooking = createAction('[Api] SAVE BOOKING', props<{ booking: Booking }>());

export const EditBooking = createAction('[Api] EDIT BOOKING', props<{ id: string; change: Partial<Booking> }>());

export const ApproveBooking = createAction('[Api] APPROVE BOOKING', props<{ id: string; change: Partial<Booking> }>());

export const CancelBooking = createAction('[Api] CANCEL BOOKING', props<{ id: string; change: Partial<Booking> }>());

export const RejectBooking = createAction('[Api] REJECT BOOKING', props<{ id: string; change: Partial<Booking> }>());

export const PaidBooking = createAction('[Api] PAID BOOKING', props<{ id: string; change: Partial<Booking> }>());

export const RegisterBooking = createAction('[Api] REGISTER BOOKING', props<{ change: Partial<Booking> }>());

export const RegisterMultiBooking = createAction('[Api] REGISTER MULTI BOOKING', props<{ bookings: Partial<Booking[]>, participants: number }>());

export const CheckBooking = createAction('[Api] CHECK BOOKING', props<{ userId: string; courseId: string }>());

export const AcceptBookingReschedule = createAction('[Api] ACCEPT BOOKING RESCHEDULE', props<{ id: string }>());

export const RefundBooking = createAction('[Api] REFUND BOOKING RESCHEDULE', props<{ userId: string, bookingId: string }>());

export const SubmitDigitalCourseReview = createAction('[Booking] SUBMIT DIGITAL COURSE REVIEW', props<{ serviceId: string, review: Review }>());
export const SubmitClassroomCourseReview = createAction('[Booking] SUBMIT CLASSROOM COURSE REVIEW', props<{ serviceId: string, review: Review }>());
export const SubmitClassroomFeedback = createAction('[Booking] SUBMIT CLASSROOM FEEDBACK', props<{ serviceId: string, feedback: Feedback }>());
export const SubmitInstructorReview = createAction('[Booking] SUBMIT CLASSROOM COURSE INSTRUCTOR REVIEW', props<{ instructorId: string, instructorReview: InstructorReview }>());

/**
 * Service Actions
 */
export const AddServiceBooking = createAction('ADD SERVICE BOOKING', props<{ booking: Booking; isInstantBooking: boolean }>());

export const RegisterServiceBooking = createAction('[Api] REGISTER SERVICE BOOKING', props<{ change: Partial<Booking>; isInstantBooking: boolean; }>());

export const SaveServiceBooking = createAction('[Api] SAVE SERVICE BOOKING', props<{ booking: Booking }>());

export const EditServiceBooking = createAction('[Api] EDIT SERVICE BOOKING', props<{ id: string; change: Partial<Booking> }>());

export const ApproveServiceBooking = createAction('[Api] APPROVE SERVICE BOOKING', props<{ id: string; change: Partial<Booking>; }>());

export const CancelServiceBooking = createAction('[Api] CANCEL SERVICE BOOKING', props<{ id: string; change: Partial<Booking> }>());

export const RejectServiceBooking = createAction('[Api] REJECT SERVICE BOOKING', props<{ id: string; change: Partial<Booking> }>());

export const PaidServiceBooking = createAction('[Api] PAID SERVICE BOOKING', props<{ id: string; change: Partial<Booking> }>());

export const UpdateServiceBooking = createAction('UPDATE SERVICE BOOKING', props<{ id: string; change: Booking }>());

export const UpdateServiceBookingSuccess = createAction('UPDATE SERVICE BOOKING SERVICE');

export const ApproveServiceBookingSuccess = createAction('APPROVE SERVICE BOOKING SUCCESS');

export const DeleteServiceBooking = createAction('DELETE SERVICE BOOKING', props<{ id: string }>());

export const SetServiceProviderId = createAction('[BOOKING] SET BOOKING SERVICE PROVIDER ID', props<{ serviceProviderId: string }>());

export const SetServiceProviderView = createAction('[BOOKING] SET BOOKING SERVICE PROVIDER VIEW', props<{ serviceProviderView: boolean }>());

export const ActivateDigitalCourseBookingInit = createAction('[BOOKING] ACTIVATE DIGITAL COURSE BOOKING INIT', props<{userId:string, bookingId: string}>());

export const ActivateDigitalCourseBookingSuccess = createAction('[BOOKING] ACTIVATE DIGITAL COURSE BOOKING SUCCESS', props<{bookingId: string}>());
